import { render, staticRenderFns } from "./GraduatedPrices.vue?vue&type=template&id=0fc0278e&"
import script from "./GraduatedPrices.vue?vue&type=script&lang=js&"
export * from "./GraduatedPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc0278e')) {
      api.createRecord('0fc0278e', component.options)
    } else {
      api.reload('0fc0278e', component.options)
    }
    module.hot.accept("./GraduatedPrices.vue?vue&type=template&id=0fc0278e&", function () {
      api.rerender('0fc0278e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/GraduatedPrices.vue"
export default component.exports